/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { Component } from '@/Constants/Component'

/**************************************************************************************************/
/** @internal Interface @name BaseElementParams                                                  **/
/**************************************************************************************************/
interface BaseElementParams
{
	button?: any
	enabled?: boolean
	formatter?: any
	optional?: boolean
	placeholder?: string
	range?: { max?: number, min?: number }
	readonly?: Array<Component.Actions>
	requires?: any
	state?: (self: any) => boolean
	type?: string
	validator?: (value: any) => boolean
	visible?: Array<Component.Actions>
}

/**************************************************************************************************/
/** @export Class @name BaseElement                                                              **/
/**************************************************************************************************/
export class BaseElement
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private key: string
	private label: string
	private params: BaseElementParams

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor()
	{
		this.params = {}
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public get Key() : string
	{
		return this.key
	}

	public set Key(value)
	{
		this.key = value
	}

	public get Label() : string
	{
		return this.label
	}

	public set Label(value)
	{
		this.label = value
	}

	public get Params() : BaseElementParams
	{
		return this.params
	}

	public isParamsOptional() : this
	{
		this.params.optional = true
		return this
	}

	public setParamsPlaceHolder(placeholder: string) : this
	{
		this.params.placeholder = placeholder
		return this
	}

	public setParamsReadOnly(...readonly: Component.Actions[]) : this
	{
		this.params.readonly = readonly
		return this
	}

	public setParamsState(f: (self: any) => boolean) : this
	{
		this.params.state = f
		return this
	}

	public setParamsValidator(f: (value: any) => boolean) : this
	{
		this.params.validator = f
		return this
	}

	public setParamsVisible(...visible: Array<Component.Actions>) : this
	{
		this.params.visible = visible
		return this
	}
}